import {
  fetchData
} from './ajax.js';
// 校验函数
const checkFunc = (func) => {
  return func && (func.constructor === Function);
};

// 根据跨域通办获取单位列表信息（有事项的单位列表）
export function unitList(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/ApprItemInterface/api/unit/unitList/6/query.v';
  return fetchData(url, ...options);
}

// 获取跨域通办事项列表
export function scopeProgramList(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'post', callFunc] : [data, 'post'];
  let url = '/ApprItemInterface/api/program/scopeProgramList/1/query.v';
  return fetchData(url, ...options);
}

//获取审批事项列表
export function wholeCityItemList(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/CommonService/api/apprItem/wholeCityItemList/query.v';
  return fetchData(url, ...options);
}

//获取全市通办地区选择列表（只展示区县级）
export function wholeCityAreaList(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/CommonService/api/apprItem/wholeCityAreaList/query.v';
  return fetchData(url, ...options);
}

//根据地区流水号获取全市通办事项选择列表
export function wholeCityItemListByArea(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/CommonService/api/apprItem/wholeCityItemListByArea/query.v';
  return fetchData(url, ...options);
}

//根据事项名称获取全市通办单位选择列表
export function wholeCityUnitListByApprove(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/CommonService/api/apprItem/wholeCityUnitListByApprove/query.v';
  return fetchData(url, ...options);
}

//外网参数
export function outnetConfig(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/ApprNetInterface/api/sys/outnetConfig/query.v';
  return fetchData(url, ...options);
}

//通过ip地址定位当前城市
export function getCityByNet(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'post', callFunc] : [data, 'post'];
  let url = '/ApiSohu/cityjson?ie=utf-8';
  return fetchData(url, ...options);
}

// 获取跨域通办地区列表(1、外省可办的湛江事项/3、省内可办的湛江事项)
export function scopeAreaList2(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/ApprItemInterface/api/area/areaList/2/query.v';
  return fetchData(url, ...options);
}

// 获取跨域通办地区列表（2、湛江可办的外省事项/4、湛江可办的省内事项）
export function scopeAreaList3(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/ApprItemInterface/api/area/areaList/3/query.v';
  return fetchData(url, ...options);
}

// 获取跨域通办事项大厅列表
export function getCrossHallInfoList(data, callFunc) {
  const options = checkFunc(callFunc) ? [data, 'get', callFunc] : [data, 'get'];
  let url = '/CommonService/api/apprItem/getCrossHallInfoList/query.v';
  return fetchData(url, ...options);
}